import {Container ,Breadcrumb, Row, Col} from "react-bootstrap";
import MainNav from "../../blocks/MainNav";
import {NavLink} from 'react-router-dom';
import Breams from "../../blocks/Breams";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowLeft, faSignOutAlt} from "@fortawesome/free-solid-svg-icons";

export default function TestTrainingTab(props) {
    
    

    return <>
            <div className="Breams">
                <Container className={"pb-0"}>
                    <Breadcrumb className={"Breams-Nav"}>
                        <Breadcrumb.Item className={"Breams-Item"} active>{props.t('Personal Area')}</Breadcrumb.Item>
                        <Breadcrumb.Item className={"Breams-Item"} active>{props.t('Training module')}</Breadcrumb.Item>
                    </Breadcrumb>
                </Container>
            </div>
           <div className="Screen container mx-auto">
                <Row className={"ScreenCabinet-Row"}>
                    <Col xs="12" xl="6" className={"ScreenCabinet-Col cursor-pointer"} >
                        <div onClick={()=>{props.selectTreaningType('byAssignedTests')}} className={"d-flex align-items-center justify-content-start Btn Btn_success text-white p-5"}>
                            <div className="demoQuest__text d-flex">
                                Тренировка по назначенным тестам
                            </div>
                        </div>
                    </Col>
                    <Col xs="12" xl="6" className={"ScreenCabinet-Col cursor-pointer"} >
                        <div  onClick={()=>{props.selectTreaningType('byBaseTests')}} className={"d-flex align-items-center justify-content-start Btn Btn_success text-white p-5"}>
                            <div className="demoQuest__text d-flex">
                                Тренировка по общим тестам
                            </div>
                        </div>
                    </Col>
                    <Col xs="12" xl="6" className={"ScreenCabinet-Col cursor-pointer"}>
                        <div onClick={()=>{props.selectTreaningType('bySpecialTests')}} className={"d-flex align-items-center justify-content-start Btn Btn_success text-white p-5"}>
                            <div className="demoQuest__text d-flex">
                                Тренировка по специальным наборам
                            </div>
                        </div>
                    </Col>
                    <Col xs="12" xl="6" className={"ScreenCabinet-Col cursor-pointer"}>
                        <div onClick={()=>{props.handleViewResults()}} className={"d-flex align-items-center justify-content-start Btn Btn_secondary text-white p-5"}>
                            <div className="demoQuest__text d-flex">
                                Просмотреть результаты тренировок
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <MainNav>
                <Container className={`d-flex justify-content-between`}>
                    <NavLink to={"/cabinet"} className={`Btn Btn_success MuiButton`}>
                        <FontAwesomeIcon className="mr-4" icon={faArrowLeft}/>
                        <span>{props.t('Personal Area')}</span>
                    </NavLink>
                    <NavLink to={"/"} className={`Btn Btn_danger MuiButton`}>
                        <FontAwesomeIcon className="mr-4" icon={faSignOutAlt}/>
                        <span>{props.t('Exit')}</span>
                    </NavLink>
                </Container>
            </MainNav>
    </>
}
